// ✅ Common reusable price comparison method
export const isPriceWithinBudget = (budget, milestoneList) => {
  const totalMilestoneAmount = (milestoneList || []).reduce((sum, m) => {
    const amount = parseFloat(m?.amount) || 0;
    return sum + amount;
  }, 0);

  // ✅ Return true if total milestone amounts <= project budget
  return totalMilestoneAmount <= parseFloat(budget || 0);
};
